import React from "react";

/**
 * Styled content blocks for SEO pages — preserves brand tokens (primary/secondary).
 */

export const SeoSection: React.FC<{ title: string; children: React.ReactNode }> = ({ title, children }) => (
  <section className="mb-10 sm:mb-12">
    <h2 className="text-xl sm:text-2xl md:text-3xl font-cinzel font-bold text-primary uppercase tracking-wide mb-3">
      {title}
    </h2>
    <div className="w-12 h-px bg-secondary mb-5" />
    <div className="space-y-4 text-base sm:text-lg text-foreground/80 font-montserrat leading-relaxed">
      {children}
    </div>
  </section>
);

export const SeoSubSection: React.FC<{ title: string; children: React.ReactNode }> = ({ title, children }) => (
  <div className="mt-6 mb-4">
    <h3 className="text-lg sm:text-xl font-cinzel font-semibold text-secondary mb-2">{title}</h3>
    <div className="space-y-3 text-base text-foreground/80 font-montserrat leading-relaxed">
      {children}
    </div>
  </div>
);

export const SeoList: React.FC<{ items: string[] }> = ({ items }) => (
  <ul className="space-y-2 list-disc list-inside marker:text-secondary">
    {items.map((item, i) => (
      <li key={i} className="text-base text-foreground/80 font-montserrat">
        {item}
      </li>
    ))}
  </ul>
);
